import type { FiltreTickets, TriTickets } from '../../Services/tickets-query';

type OptionFiltre = { valeur: FiltreTickets; libelle: string };
type GroupeFiltres = { titre: string; aide: string; filtres: readonly OptionFiltre[] };

export const GROUPES_FILTRES_TICKETS: readonly GroupeFiltres[] = [
  {
    titre: 'Nouveautés',
    aide: 'Chaque critère sélectionné doit être satisfait.',
    filtres: [
      { valeur: 'nouveaux_messages', libelle: 'Nouveaux messages' },
      { valeur: 'nouveaux_bons_intervention', libelle: 'Nouveaux bons d’intervention' },
    ],
  },
  {
    titre: 'Interventions',
    aide: 'Au moins une des situations sélectionnées.',
    filtres: [
      { valeur: 'curatives_non_planifiees', libelle: 'Interventions curatives non planifiées' },
      { valeur: 'curatives_planifiees', libelle: 'Interventions curatives planifiées' },
      {
        valeur: 'curatives_planifiees_depassees',
        libelle: 'Interventions curatives planifiées dépassées',
      },
      { valeur: 'preventives_planifiees', libelle: 'Interventions préventives planifiées' },
    ],
  },
  {
    titre: 'Types de défauts',
    aide: 'Au moins un des types sélectionnés.',
    filtres: [
      { valeur: 'defauts_communication', libelle: 'Défauts communication' },
      { valeur: 'arret_production_centrale', libelle: 'Défauts arrêt production centrale' },
      { valeur: 'perte_production_centrale', libelle: 'Défauts perte production centrale' },
      { valeur: 'arret_production_onduleurs', libelle: 'Défauts arrêt production onduleurs' },
      { valeur: 'perte_production_onduleurs', libelle: 'Défauts perte production onduleurs' },
      { valeur: 'autres', libelle: 'Défauts autres' },
    ],
  },
];

export const FILTRES_TICKETS: readonly OptionFiltre[] = GROUPES_FILTRES_TICKETS.flatMap(
  (groupe) => groupe.filtres,
);

export const TRIS_TICKETS: readonly { valeur: TriTickets; libelle: string }[] = [
  { valeur: 'date', libelle: 'Trier par date' },
  { valeur: 'libelle', libelle: 'Trier par libellé' },
];
